import React from "react";
import { Link } from "react-router-dom";

const IDMergeSection: React.FC = () => {
  const categories = [
    {
      title: "Popular",
      links: [
        "Aadhar Card Merge",
        "CNIC Card Combine",
        "Passport Merge",
        "Driving License Combine",
        "Student ID Merge",
        "Work ID Merge",
        "National ID Merge",
        "Resident Permit Merge",
        "Health Insurance ID Merge",
        "Senior Citizen ID Merge",
      ],
    },
    {
      title: "Other IDs",
      links: [
        "Passport Merge",
        "Driving License Combine",
        "Work & Student",
        "Student ID Merge",
        "Work ID Merge",
        "Military ID Merge",
        "Voter ID Merge",
        "Social Security ID Merge",
        "Government Employee ID Merge",
        "Company ID Merge",
      ],
    },
    {
      title: "Popular Countries",
      links: [
        "USA ID Merge",
        "UK ID Merge",
        "Canada ID Merge",
        "Australia ID Merge",
        "India ID Merge",
        "Germany ID Merge",
        "France ID Merge",
        "Italy ID Merge",
        "Japan ID Merge",
        "UAE ID Merge",
      ],
    },
  ];

  return (
    <section className="w-full mx-auto text-gray-700 relative z-10">
    <div className="w-full px-4 sm:px-8 md:px-16 lg:px-24 py-16 md:py-20 lg:py-24 bg-gradient-to-br from-[#f5f7fa] via-[#edf2f7] to-[#e2e8f0] rounded-3xl shadow-inner overflow-hidden relative">
      {/* Decorative Background Blobs */}
      <div className="absolute top-[-5rem] right-[-5rem] w-72 h-72 bg-blue-300 opacity-20 blur-3xl rounded-full z-0 animate-pulse"></div>
      <div className="absolute bottom-[-4rem] left-[-4rem] w-52 h-52 bg-purple-300 opacity-20 blur-3xl rounded-full z-0 animate-pulse"></div>
  
      {/* Section Title */}
      <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-center tracking-tight leading-tight">
        <span className="bg-black bg-clip-text text-transparent">ID Merge Services</span>
      </h2>
  
      {/* Section Description */}
      <p className="text-sm sm:text-base md:text-lg text-gray-700 text-center leading-relaxed max-w-5xl mx-auto mb-12 px-2">
        Seamlessly unify duplicate or fragmented user identities into a single, secure profile. Improve data accuracy and user experience with smart identity merging.
      </p>
  
      {/* Category Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10">
        {categories.map((category, index) => (
          <div
            key={index}
            className="relative group bg-white border border-gray-100 shadow-xl rounded-3xl p-6 md:p-8 overflow-hidden transition-all duration-300 hover:shadow-2xl hover:border-blue-300"
          >
            {/* Background Effects */}
            <div className="absolute -top-10 -left-10 w-40 h-40 bg-gradient-to-br from-blue-400 to-purple-500 opacity-10 blur-3xl rounded-full z-0"></div>
            <div className="absolute bottom-0 right-0 w-28 h-28 bg-pink-400/10 blur-2xl rounded-full z-0"></div>
  
            {/* Card Content */}
            <div className="relative z-10">
              <h3 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-4 transition-colors group-hover:text-blue-600 tracking-tight">
                {category.title}
              </h3>
  
              <ul className="space-y-3 sm:space-y-4">
                {category.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link
                      to="/id-card"
                      className="flex items-center gap-3 text-gray-700 hover:text-blue-700 transition font-medium text-sm sm:text-base"
                    >
                      <span className="w-2.5 h-2.5 bg-gradient-to-tr from-blue-500 to-purple-500 rounded-full shadow-sm group-hover:scale-110 transition-transform" />
                      {link}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
  

  );
};

export default IDMergeSection;
